import { PortalModule } from '@angular/cdk/portal';
import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NStepContentDirective } from './n-step-content.directive';
import { NStepHeaderComponent } from './n-step-header.component';
import { NStepLabelDirective } from './n-step-label.directive';
import { NStepComponent } from './n-step.component';
import { NStepperNextDirective, NStepperPreviousDirective } from './n-stepper-buttons';
import { NStepperComponent } from './n-stepper.component';

const components = [
  NStepComponent,
  NStepContentDirective,
  NStepHeaderComponent,
  NStepLabelDirective,
  NStepperComponent,
  NStepperNextDirective,
  NStepperPreviousDirective,
];

@NgModule({
  declarations: components,
  exports: [components],
  imports: [CommonModule, CdkStepperModule, PortalModule],
})
export class StepperModule {}
